import { Link, NavLink } from "react-router-dom";
import { useLang, withLangPath } from "@/i18n";

// Sostituti drop-in di Link/NavLink di react-router: aggiungono
// automaticamente il prefisso della lingua corrente a `to`, così un
// click su un link interno non fa mai "perdere" la lingua attiva.
export const LocalizedLink = ({ to, ...props }) => {
  const { lang } = useLang();
  return <Link to={withLangPath(to, lang)} {...props} />;
};

export const LocalizedNavLink = ({ to, ...props }) => {
  const { lang } = useLang();
  return <NavLink to={withLangPath(to, lang)} {...props} />;
};
